import React, { FunctionComponent } from "react";
import {
  EnrollmentFormProps,
  EnrollmentFormProps2021,
  EnrollmentFormProps2022,
} from "./EnrollmentFormPage";
import Enroll2020 from "./2020";
import Enroll2021 from "./2021";
import Enroll2022 from "./2022";
import { EnrollmentPages } from "../../helpers";

const CurrentFormPage: FunctionComponent<(
  | EnrollmentFormProps
  | EnrollmentFormProps2021
  | EnrollmentFormProps2022
) & {
  currentPage: EnrollmentPages;
}> = props => {
  const components = {
    "2020": {
      [EnrollmentPages.Sep]: Enroll2020.SepEnrollments,
      [EnrollmentPages.MedicareInfo]: Enroll2020.MedicareInfo,
      [EnrollmentPages.Address]: Enroll2020.Address,
      [EnrollmentPages.PersonalInfo]: Enroll2020.PersonalInfo,
      [EnrollmentPages.GeneralQuestions]: Enroll2020.GeneralQuestions,
      [EnrollmentPages.Paying]: Enroll2020.Paying,
      [EnrollmentPages.Agreement]: Enroll2020.Agreement,
      [EnrollmentPages.Review]: Enroll2020.Review,
      [EnrollmentPages.Enrolled]: Enroll2020.Enrolled,
    },
    "2021": {
      [EnrollmentPages.Sep]: Enroll2021.SepEnrollments,
      [EnrollmentPages.MedicareInfo]: Enroll2021.MedicareInfo,
      [EnrollmentPages.Address]: Enroll2021.Address,
      [EnrollmentPages.PersonalInfo]: Enroll2021.PersonalInfo,
      [EnrollmentPages.GeneralQuestions]: Enroll2021.GeneralQuestions,
      [EnrollmentPages.Paying]: Enroll2021.Paying,
      [EnrollmentPages.Agreement]: Enroll2021.Agreement,
      [EnrollmentPages.Review]: Enroll2021.Review,
      [EnrollmentPages.Enrolled]: Enroll2021.Enrolled,
    },
    "2022": {
      [EnrollmentPages.Sep]: Enroll2022.SepEnrollments,
      [EnrollmentPages.MedicareInfo]: Enroll2022.MedicareInfo,
      [EnrollmentPages.Address]: Enroll2022.Address,
      [EnrollmentPages.PersonalInfo]: Enroll2022.PersonalInfo,
      [EnrollmentPages.GeneralQuestions]: Enroll2022.GeneralQuestions,
      [EnrollmentPages.Paying]: Enroll2022.Paying,
      [EnrollmentPages.Agreement]: Enroll2022.Agreement,
      [EnrollmentPages.Review]: Enroll2022.Review,
      [EnrollmentPages.Enrolled]: Enroll2022.Enrolled,
    },
  };

  /* istanbul ignore next: built-in functionality */
  const PageComponent = components[props.plan.contract_year][props.currentPage];

  if (!PageComponent) {
    return null;
  }

  return <PageComponent {...props} />;
};

export default CurrentFormPage;
